import React from "react";
import { Link } from "react-router-dom";

export default function ToolCard({ tool }) {
  const isSoon = tool.status === "soon";

  return (
    <Link
      to={tool.path}
      className="card card-hover"
      style={{
        textDecoration: "none",
        color: "inherit",
        opacity: isSoon ? 0.85 : 1,
        pointerEvents: isSoon ? "none" : "auto",
      }}
      aria-label={tool.title}
    >
      {/* Tout le contenu reste NORMAL, le hover est géré par la card */}
      <div
        style={{ display: "flex", justifyContent: "space-between", gap: 10 }}
      >
        <h3 style={{ margin: 0, fontSize: 16 }}>{tool.title}</h3>
        <span style={{ fontSize: 12, opacity: 0.65 }}>{tool.category}</span>
      </div>

      <p style={{ marginTop: 8, marginBottom: 10, opacity: 0.75 }}>
        {tool.desc}
      </p>

      <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
        {(tool.tags || []).slice(0, 4).map((tag) => (
          <span
            key={tag}
            style={{
              fontSize: 12,
              padding: "4px 8px",
              borderRadius: 999,
              border: "1px solid rgba(255,255,255,.18)",
              opacity: 0.85,
            }}
          >
            {tag}
          </span>
        ))}

        {isSoon && (
          <span
            style={{
              marginLeft: "auto",
              fontSize: 12,
              padding: "4px 8px",
              borderRadius: 999,
              border: "1px solid rgba(255,255,255,.25)",
              opacity: 0.9,
            }}
          >
            Bientôt
          </span>
        )}
      </div>
    </Link>
  );
}
